import React from 'react'
import html from '../img/html.png'
import css from '../img/css.png'
import javascript from '../img/javascript.png'
import react from '../img/react.png'
import tailwind from '../img/tailwind.png'
import node from '../img/node (1).png'
import php from '../img/php.png'
import firebase from '../img/firebase.png'
import mysql from '../img/mysql.png'
import mongo from '../img/mongodb.png'
import android from '../img/android.png'
import java from '../img/java.png'
import { keyframes } from 'styled-components';

const trendingAnimation = keyframes`
  0% {
    transform: translateY(-2px); /* Initial position */
  }
  50% {
    transform: translateY(2px); /* Move down slightly */
  }
  100% {
    transform: translateY(-2px); /* Return to initial position */
  }
`;

const Skills = () => {
  return (
<> 

    <div className='bg-black' >
 <div className=' mb-10 flex flex-col justify-center items-center my-0' >
  <p className='text-4xl mb-3 font-bold primary-color text-center mt-14'>Skills</p>
  <p className='text-gray-400 text-2xl text-center primary-color mb-8'>"Fluent in code, crafting digital wonders."</p>
</div>

    <div className=' text-gray-400 md:h-[150px] max-w-[100%] mx-auto grid grid-cols-6
    place-items-center md:flex md:justify-between md:items-center mb-10'>



<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px] ">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={html} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>HTML</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={css} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>CSS</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={javascript} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Javascript</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={react} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>REACT</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={tailwind} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Tailwind CSS</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={php} alt='' className=" w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>PHP</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
</div>

<div className=' text-gray-400 md:h-[188px] max-w-[1200px] mx-auto grid grid-cols-6
    place-items-center md:flex md:justify-between md:items-center'>



<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={java} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Java</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>

<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={android} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Android</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={firebase} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Firebase</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={mysql} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>MySQL</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className="flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={mongo} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Mongodb</p>
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>
<div className=" flex flex-col items-center m-4 sm:my-0 w-[40px] md:w-[100px]">
  <div className="rounded-full shadow-blue-lg bg-white p-2 hover:scale-110 transition-transform transform-gpu">
    <img src={node} alt='' className="w-full h-full object-contain rounded-full" />
  </div>
  <p className='mt-2'>Node JS</p>
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full animate-trending" style={{ animationDelay: "0.1s" }} />
      </div>
</div>

    </div>
    </div>

    </>
    
  )
}

export default Skills